const API_URL = process.env.REACT_APP_API_URL;

// GET liste des utilisateurs
export async function getUsers() {
    const response = await fetch(`${API_URL}/utilisateur`, {
      method: "GET",
      credentials: "include",
    });
  
    if (!response.ok) {
      throw new Error("Non authentifié");
    }
  
    return response.json();
}

// GET un utilisateur par ID
export async function getUserById(userId) {
    const response = await fetch(`${API_URL}/utilisateur/${userId}`, {
      method: "GET",
      credentials: "include",
    });
  
    if (!response.ok) {
      throw new Error("Utilisateur non trouvé");
    }
  
    return response.json();
}

// POST créer un utilisateur
export async function createUser(userData) {
    const response = await fetch(`${API_URL}/utilisateur`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        utilisateur: {
          nom: userData.nom,
          prenom: userData.prenom,
          email: userData.email,
          telephone: userData.telephone,
          couleur: userData.couleur,
          role: userData.role,
        }
      }),
    });
  
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Erreur lors de la création de l'utilisateur");
    }
  
    return response.json();
}

// PUT mettre à jour un utilisateur
export async function updateUser(userId, userData) {
    const response = await fetch(`${API_URL}/utilisateur/${userId}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        utilisateur: {
          nom: userData.nom,
          prenom: userData.prenom,
          email: userData.email,
          telephone: userData.telephone,
          couleur: userData.couleur
        }
      }),
    });
  
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Erreur lors de la mise à jour de l'utilisateur");
    }
  
    return response.json();
}
  
  export async function deleteUser(userId) {
    const response = await fetch(`${API_URL}/utilisateur/${userId}`, {
        method: "DELETE",
        credentials: "include",
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Erreur lors de la suppression de l'utilisateur");
    }

    return response.json();
}

  export async function getGroupesByUserId(userId) {
    const response = await fetch(`${API_URL}/utilisateur/${userId}/groupes`, {
      method: "GET",
      credentials: "include",
    });
  
    if (!response.ok) {
      throw new Error("Non authentifié");
    }
  
    return response.json();
  }
  // POST ajouter des groupes à un utilisateur
  export async function addUserToGroups(userId, groupIds) {
    const response = await fetch(`${API_URL}/utilisateur/${userId}/groupes`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        utilisateur: {
          groupes: groupIds
        }
      }),
    });
  
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Erreur lors de l'ajout aux groupes");
    }
  
    return response.json();
  }

  // DELETE retirer des groupes d'un utilisateur
  export async function removeUserFromGroups(userId, groupIds) {
    const response = await fetch(`${API_URL}/utilisateur/${userId}/groupes`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        utilisateur: {
          groupes: groupIds
        }
      }),
    });
  
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Erreur lors du retrait des groupes");
    }
  
    return response.json();
  }

// POST changer le mot de passe d'un utilisateur (admin)
export async function changeUserPassword(userId, newPassword) {
  const response = await fetch(`${API_URL}/utilisateur/${userId}/mot-de-passe`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      mot_de_passe: { nouveau: newPassword },
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Erreur lors du changement de mot de passe");
  }

  return response.json();
}

// Update current user profile (deprecated - use updateUser instead)
  export async function updateUserProfile(userId, userData) {
    const response = await fetch(`${API_URL}/utilisateur/${userId}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });
  
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Erreur lors de la mise à jour du profil");
    }
  
    return response.json();
  }